// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const saveToLocalStorage = (data: any, key: string): void => {
	try {
		localStorage && localStorage.setItem(key, JSON.stringify(data));
	} catch (error) {
		console.warn('Can’t write to local storage:', (error as Error).message);
	}
};
